<template>
  <app-timeline>
    <app-timeline-item
      v-for="(timeline, index) in escalationTimelineList"
      :key="index"
    >
      <span class="text-uppercase text-semibold-black">
        level {{ index + 1 }}
      </span>
      <span class="font-size-12 pl-1"> ({{ timeline.escalationTime }}) </span>
      <atom-escalation-avatar
        class="mt-1 custom-max-width"
        :name="timeline.name"
        :role="timeline.role"
        :contact-phone="timeline.contactPhone"
        :contact-email="timeline.contactEmail"
        :system-notification="timeline.systemNotification"
        :email-notification="timeline.emailNotification"
        :line-notification="timeline.lineNotification"
      ></atom-escalation-avatar>
    </app-timeline-item>
  </app-timeline>
</template>

<script>
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue"
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue"
import AtomEscalationAvatar from "@/components/atoms/AtomEscalationAvatar.vue"

export default {
  name: "MoleculeEscalationTimeline",
  components: {
    AppTimeline,
    AppTimelineItem,
    AtomEscalationAvatar,
  },
  props: {
    escalationTimelineList: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .custom-max-width {
    max-width: 70%;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .custom-max-width {
    max-width: 100%;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
